import ShowMessage from 'components/ShowMessage/ShowMessage';

const ResponseConfirmation = () => {
  return (
    <ShowMessage>
      <h1>Thank you!</h1>
      <p>
        Your feedback has been successfully submitted. We appreciate your time and help improving
        our services.
      </p>
    </ShowMessage>
  );
};

export default ResponseConfirmation;
